import { http } from '@/core/api/';

const hrBaseURL = 'api/hrserviceassistant';

export const saveServiceAssistant = async (data) => {
  return await http.post(`${hrBaseURL}/serviceassistant/save`, data);
};

export const updateServiceAssistant = async (data) => {
  return await http.put(`${hrBaseURL}/serviceassistant/edit`, data);
};

export const assignStudentToAssistant = async (data) => {
  return await http.post(`${hrBaseURL}/assignstudent`, data);
};

export const deleteStudentToAssistant = async (id) => {
  return await http.put(`${hrBaseURL}/deletestudent/${id}`);
};

export const getServiceAssistantsStudents = async (data) => {
  return await http.get(`${hrBaseURL}/searchassistantsstudents`, {
    params: {
      ...data,
    },
  });
};
